// extracted by mini-css-extract-plugin
module.exports = {"productSwatch":"product-swatch_productSwatch__reSv_","swatch":"product-swatch_swatch__kBh7m"};